import toast from "react-hot-toast";
var DEFAULT_TIMEOUT = 1500;
var successOptions = {
  duration: 4500,
  position: "bottom-center",
  style: {
    background: "#00b894",
    color: "#fff",
    borderColor: "#00b894"
  }
};
var errorOptions = {
  duration: 4500,
  position: "bottom-center",
  style: {
    background: "#d63031",
    color: "#fff",
    borderColor: "#d63031"
  }
};
function useAlertsToaster() {
  var successToasterFunction = function successToasterFunction(successMessage) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_TIMEOUT;
    setTimeout(function () {
      toast.success(successMessage, successOptions);
    }, timeout);
  };
  var errorToasterFunction = function errorToasterFunction(errorMessage) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_TIMEOUT;
    setTimeout(function () {
      toast.error(errorMessage, errorOptions);
    }, timeout);
  };
  return {
    successToast: successToasterFunction,
    errorToast: errorToasterFunction
  };
}
export default useAlertsToaster;